import React from "react";
import "../assets/css/secondaryPayment.css";
// import { X } from "lucide-react";

const SecondaryModal = ({ setIsOpen, children }) => {
  return (
    <div className="secondary-modal-container">
      <div className="secondary-modal-content">
        {/* <div className="close" onClick={() => setIsOpen(false)}>
          <X />
        </div> */}
        {children}
      </div>
    </div>
  );
};

export default SecondaryModal;
